/**
 * Dashboard Layout Component
 * Carbon UI Shell compliant layout for all user roles
 * Uses the new CarbonUIShell for fully compliant navigation
 */

import React from 'react';
import CarbonUIShell from './CarbonUIShell';

interface DashboardLayoutProps {
  children?: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return <CarbonUIShell>{children}</CarbonUIShell>;
};

export default DashboardLayout;
